import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import TrueFalseEmbed from '../components/Exercise/TrueFalseEmbed';

export default Node.create({
  name: 'trueFalseExercise',
  
  group: 'block',
  
  atom: true,
  draggable: true,
  
  addAttributes() {
    return {
      statements: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('statements');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing TrueFalse statements from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.statements) {
            return {
              statements: JSON.stringify(attributes.statements)
            };
          }
          return {};
        }
      },
      title: {
        default: 'True/False Exercise',
        parseHTML: element => element.getAttribute('title') || 'True/False Exercise',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {},
      }
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'div[data-type="true-false-exercise"]',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'true-false-exercise' })];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(TrueFalseEmbed);
  },
  
  addCommands() {
    return {
      insertTrueFalseExercise:
        (attributes = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 